// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Css_Js_Core from "bs-css/src/Css_Js_Core.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Kontent$PrezzeeRibbon from "../../personal/Kontent/Kontent.bs.js";
import * as ThemeContext$PrezzeeRibbon from "../../../context/ThemeContext/ThemeContext.bs.js";
import * as Theme__Animation$PrezzeeRibbon from "../../../theme/Theme__Animation.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";
import * as Theme__Typography$PrezzeeRibbon from "../../../theme/Theme__Typography.bs.js";

var wrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.textDecoration(BsCssJs$PrezzeeRibbon.none),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.unsafe("maxHeight", "260px"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))
          ])
    ]);

function tileThemeStyles(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius),
              BsCssJs$PrezzeeRibbon.after([
                    BsCssJs$PrezzeeRibbon.background(match.categoryTile.overlayColor),
                    BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius)
                  ])
            ]);
}

var categoryTile = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.position(BsCssJs$PrezzeeRibbon.relative),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("flexEnd"),
      BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.regular),
      BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeOut"),
      BsCssJs$PrezzeeRibbon.transitionProperty("transform box-shadow"),
      BsCssJs$PrezzeeRibbon.after([
            BsCssJs$PrezzeeRibbon.contentRule({
                  NAME: "text",
                  VAL: ""
                }),
            BsCssJs$PrezzeeRibbon.unsafe("mixBlendMode", "overlay"),
            BsCssJs$PrezzeeRibbon.opacity(0.1),
            BsCssJs$PrezzeeRibbon.position(BsCssJs$PrezzeeRibbon.absolute),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100))
          ]),
      BsCssJs$PrezzeeRibbon.hover([
            BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateY(BsCssJs$PrezzeeRibbon.px(-4))),
            BsCssJs$PrezzeeRibbon.boxShadow(Css_Js_Core.Shadow.box(BsCssJs$PrezzeeRibbon.px(11), BsCssJs$PrezzeeRibbon.px(9), BsCssJs$PrezzeeRibbon.px(30), undefined, undefined, BsCssJs$PrezzeeRibbon.rgba(0, 0, 0, {
                          NAME: "percent",
                          VAL: 15.0
                        }))),
            BsCssJs$PrezzeeRibbon.selector("img", [
                  BsCssJs$PrezzeeRibbon.transform({
                        NAME: "scale",
                        VAL: [
                          1.07,
                          1.07
                        ]
                      }),
                  BsCssJs$PrezzeeRibbon.transitionDuration(Theme__Animation$PrezzeeRibbon.extraSlow),
                  BsCssJs$PrezzeeRibbon.transitionTimingFunction("easeOut")
                ])
          ])
    ]);

function imageWrapperThemeStyles(theme) {
  return BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.borderRadius(theme.borderRadius)]);
}

var imageWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.overflow("hidden"),
      BsCssJs$PrezzeeRibbon.selector("img", [
            BsCssJs$PrezzeeRibbon.objectFit("cover"),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.transitionDuration((Theme__Animation$PrezzeeRibbon.slow << 2)),
            BsCssJs$PrezzeeRibbon.transitionTimingFunction("ease"),
            BsCssJs$PrezzeeRibbon.transitionProperty("transform")
          ])
    ]);

function bottomTextThemeStyles(theme) {
  var match = theme.components;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.color(match.categoryTile.color),
              BsCssJs$PrezzeeRibbon.fontFamilies(theme.displayFont)
            ]);
}

var bottomText = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.875)),
      BsCssJs$PrezzeeRibbon.position(BsCssJs$PrezzeeRibbon.absolute),
      BsCssJs$PrezzeeRibbon.zIndex(1),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.lineHeight({
            NAME: "abs",
            VAL: 1.0625
          }),
      BsCssJs$PrezzeeRibbon.fontStyle("italic"),
      BsCssJs$PrezzeeRibbon.fontWeight("normal"),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrDesktop, [BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.em(0.5))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [BsCssJs$PrezzeeRibbon.paddingBottom(BsCssJs$PrezzeeRibbon.px(10))]),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.tabletOrMobile, [BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.375))])
    ]);

function decoThemeStyles(theme, labelBackgroundColor) {
  var match = theme.components;
  var categoryTile = match.categoryTile;
  return BsCssJs$PrezzeeRibbon.style([
              BsCssJs$PrezzeeRibbon.backgroundColor(Belt_Option.getWithDefault(labelBackgroundColor, categoryTile.decoColor)),
              BsCssJs$PrezzeeRibbon.color(categoryTile.color),
              BsCssJs$PrezzeeRibbon.before([
                    BsCssJs$PrezzeeRibbon.borderTopColor(Belt_Option.getWithDefault(labelBackgroundColor, categoryTile.decoColor)),
                    BsCssJs$PrezzeeRibbon.borderBottomColor(Belt_Option.getWithDefault(labelBackgroundColor, categoryTile.decoColor))
                  ])
            ]);
}

var deco = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(53)),
      BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.px(16)),
      BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.px(5)),
      BsCssJs$PrezzeeRibbon.display("flex"),
      BsCssJs$PrezzeeRibbon.alignItems("center"),
      BsCssJs$PrezzeeRibbon.position("relative"),
      BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(86)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
            BsCssJs$PrezzeeRibbon.marginRight(BsCssJs$PrezzeeRibbon.px(25)),
            BsCssJs$PrezzeeRibbon.height(BsCssJs$PrezzeeRibbon.px(70))
          ]),
      BsCssJs$PrezzeeRibbon.before([
            BsCssJs$PrezzeeRibbon.contentRule({
                  NAME: "text",
                  VAL: ""
                }),
            BsCssJs$PrezzeeRibbon.boxSizing("borderBox"),
            BsCssJs$PrezzeeRibbon.display("block"),
            BsCssJs$PrezzeeRibbon.position("absolute"),
            BsCssJs$PrezzeeRibbon.zIndex(1),
            BsCssJs$PrezzeeRibbon.top(BsCssJs$PrezzeeRibbon.pct(0)),
            BsCssJs$PrezzeeRibbon.left(BsCssJs$PrezzeeRibbon.pct(100)),
            BsCssJs$PrezzeeRibbon.transform(BsCssJs$PrezzeeRibbon.translateX(BsCssJs$PrezzeeRibbon.pct(-50))),
            BsCssJs$PrezzeeRibbon.borderStyle("solid"),
            BsCssJs$PrezzeeRibbon.borderLeftColor("transparent"),
            BsCssJs$PrezzeeRibbon.borderRightColor("transparent"),
            BsCssJs$PrezzeeRibbon.borderTopWidth(BsCssJs$PrezzeeRibbon.px(43)),
            BsCssJs$PrezzeeRibbon.borderBottomWidth(BsCssJs$PrezzeeRibbon.px(43)),
            BsCssJs$PrezzeeRibbon.borderLeftWidth(BsCssJs$PrezzeeRibbon.px(32)),
            BsCssJs$PrezzeeRibbon.borderRightWidth(BsCssJs$PrezzeeRibbon.px(32)),
            BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.mobile, [
                  BsCssJs$PrezzeeRibbon.borderTopWidth(BsCssJs$PrezzeeRibbon.px(35)),
                  BsCssJs$PrezzeeRibbon.borderBottomWidth(BsCssJs$PrezzeeRibbon.px(35)),
                  BsCssJs$PrezzeeRibbon.borderLeftWidth(BsCssJs$PrezzeeRibbon.px(20)),
                  BsCssJs$PrezzeeRibbon.borderRightWidth(BsCssJs$PrezzeeRibbon.px(20))
                ])
          ]),
      BsCssJs$PrezzeeRibbon.selector("span", [
            BsCssJs$PrezzeeRibbon.position("relative"),
            BsCssJs$PrezzeeRibbon.zIndex(2)
          ])
    ]);

var Styles = {
  wrapper: wrapper,
  tileThemeStyles: tileThemeStyles,
  categoryTile: categoryTile,
  imageWrapperThemeStyles: imageWrapperThemeStyles,
  imageWrapper: imageWrapper,
  bottomTextThemeStyles: bottomTextThemeStyles,
  bottomText: bottomText,
  decoThemeStyles: decoThemeStyles,
  deco: deco
};

function CategoryTiles__Single(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  var theme = ThemeContext$PrezzeeRibbon.useTheme(undefined);
  return JsxRuntime.jsx(Kontent$PrezzeeRibbon.Consumer.make, {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: props.children,
                                  className: Classnames([
                                        imageWrapper,
                                        imageWrapperThemeStyles(theme)
                                      ])
                                }),
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx("div", {
                                        children: JsxRuntime.jsx("span", {
                                              children: props.text
                                            }),
                                        className: Classnames([
                                              deco,
                                              decoThemeStyles(theme, Belt_Option.map(props.labelBackgroundColor, (function (c) {
                                                          return {
                                                                  NAME: "hex",
                                                                  VAL: c.replace("#", "")
                                                                };
                                                        })))
                                            ])
                                      }),
                                  className: Classnames([
                                        Theme__Typography$PrezzeeRibbon.Styles.style2,
                                        bottomTextThemeStyles(theme),
                                        bottomText
                                      ])
                                })
                          ],
                          className: Classnames([
                                categoryTile,
                                tileThemeStyles(theme)
                              ])
                        }),
                    className: Classnames([
                          wrapper,
                          className$1
                        ])
                  })
            });
}

var Settings;

var make = CategoryTiles__Single;

export {
  Settings ,
  Styles ,
  make ,
}
/* wrapper Not a pure module */
